import * as React from 'react';
import ErrorMessage from 'src/components/ErrorMessage';
import styles from 'src/layouts/unauthorized/Login/Login.css';
import EmailStep from 'src/layouts/unauthorized/Login/components/EmailStep';
import IAuthData  from 'src/app/redux/modules/auth/interfaces/IAuthData';
import SsoStep from 'src/layouts/unauthorized/Login/components/SsoStep';
import mursionSupportInfo from 'src/app/data/support/supportInfo';
import { injectIntl, WrappedComponentProps } from 'react-intl';
import { TLocaleId } from 'src/i18n';

export interface ILoginProps extends WrappedComponentProps {
  enableToEditForm: boolean;
  error?: string;
  redirectUrl?: string;
}

interface ILoginState {
  data: IAuthData;
}

class LoginForm extends React.Component<ILoginProps, ILoginState> {

  public static getDerivedStateFromProps(props: ILoginProps, state: ILoginState): ILoginState {
    const { redirectUrl } = props;

    return {
      ...state,
      data: {
        ...state.data,
        redirectUrl,
      }
    };
  }

  public state: ILoginState = {
    data: {
      currentSchema: null,
      email: '',
    },
  };

  public render() {
    const { error } = this.props;

    return (
      <div className={styles.textCenter}>
      <form className={styles.loginForm}>
        {this.renderLoginForm()}
      </form>
      <ErrorMessage className={styles.error} message={error}/>
      {this.supportInfoShow() && this.renderSupportContactInfo()}
      </div>
    );
  }

  private renderSupportContactInfo = () => {
    const { intl } = this.props;
    const phoneNumber = intl.formatMessage({ id: 'MursionPortal.Support.PhoneNumber' });
    const loginIssueSummary = `${intl.formatMessage({ id: 'MursionPortal.Error.Time' })} ${intl.formatMessage({ id: 'MursionPortal.Days.Monday' })} - ${intl.formatMessage({ id: 'MursionPortal.Days.Friday' })}`;
    return (
      <div className={styles.loginIssueContent}>
        <div className={styles.loginIssueTitle}>{intl.formatMessage({ id: 'MursionPortal.Having.Issues.Logging.In' })}</div>
        <div className={styles.loginIssueText}>{intl.formatMessage({ id: 'MursionPortal.Label.Call' })} <a href={`tel:${phoneNumber}`}>{phoneNumber}</a> {intl.formatMessage({ id: 'MursionPortal.Or' })} <a href={`mailto:${mursionSupportInfo.email}`}>{mursionSupportInfo.email}</a></div>
        <div className={styles.loginIssueSummary}>{loginIssueSummary}</div>
      </div>
    );
  }

  private supportInfoShow = () => {
    const { error, intl } = this.props;

    if (!error) {
      return false;
    }
    const errorMessages: TLocaleId[] = ['MursionPortal.ErrorMessage.AuthorizationTokenIsEmpty',
      'MursionPortal.ErrorMessage.SomethingWrongWithResponse', 'MursionPortal.ErrorMessage.UnsupportedResponseFormat',
      'MursionPortal.ErrorMessage.TechnicalIssueMsg'];

    for (const errorMessage of errorMessages) {
      if (error.includes(intl.formatMessage({ id: errorMessage }))) {
        return false;
      }
    }
    return true;
  }

  private renderLoginForm = () => {
    const { enableToEditForm } = this.props;
    const { data } = this.state;

    const Component = data.currentSchema && data.currentSchema.id
      ? SsoStep
      : EmailStep;

    return (
      <Component
        data={this.state.data}
        disabled={!enableToEditForm}
        onSubmit={this.onStepSubmit}
      />
    );
  }

  private onStepSubmit = (data: IAuthData) => {
    this.setState({
      data,
    });
  }
}

export default injectIntl(LoginForm);
